module.exports = __webpack_public_path__ + "img/georgia-logo-icon.0d1267e5.png";